import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, ButtonGroup, FormGroup, Input, Label } from 'reactstrap';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import Prompt from '../../components/Prompt';
import Table, { ExpandableRow } from '../../components/ExpandableTable';

import actions from './actions';

class ListaMudancas extends Component {
  constructor (props) {
    super(props);

    this.state = {
      promptEmail: false,
      data: {
        data_mudanca: '',
        unidade: ''
      }
    };
  }

  componentDidMount () {
    this.props.actions.onLoadListaMudancas();
  }

  onChange = (field) => (e) => {
    let value = e.target.value.toUpperCase().replace(/^\s+|\s+(?=\s$|\s)/g, "");

    this.setState(state => ({
      data: {
        ...state.data,
        [field.name]: value
      }
    }));
  };

  handleToggle = field => e => {
    this.setState(state => ({
      [field]: !state[field]
    }));
  }

  dateFormat (value) {
    return !!value && moment(value).format("DD/MM/YYYY HH:mm");
  }

  removeItem = item => e => {
    e.preventDefault();
    e.stopPropagation();

    this.props.actions.cancelaMudanca(item);
  };

  adicionaMudanca = data => {
    this.props.actions.adicionaMudanca({...this.state.data, unidade: this.state.data.unidade?this.state.data.unidade:null, ...data})
    .then(() => this.resetValues())
    .then(() => this.props.actions.onLoadListaMudancasIfNeeded())
    .catch(e => console.error(e));
  };

  addItem = entrada => () => {
    if (entrada) {
      this.setState({promptEmail: true});
    } else {
      this.adicionaMudanca({tipo: 2});
    }
  };

  addItemEmail = email => {
    this.adicionaMudanca({tipo: 1, email});
  };

  resetValues () {
    this.setState({
      promptEmail: false,
      data: {
        data_mudanca: '',
        unidade: '',
        tipo: ''
      }
    });
  }

  isValid () {
    const { data_mudanca, unidade } = this.state.data;

    return (!unidade || parseInt(unidade, 10)) && !!data_mudanca && moment().isSameOrBefore(data_mudanca, 'day');
  }

  render() {
    const { data, promptEmail } = this.state;
    const { value: { result, fetching }, actions, t } = this.props;

    let disabled = 1 === fetching || !this.isValid();

    return (<Fragment>
      <Table hover responsive size="sm">
        <thead>
          <tr>
            <th colSpan={3}>
              {1 === fetching && "Carregando..."}
            </th>
            <th className="text-right"><Button color="link" size="sm" onClick={actions.onLoadListaMudancasIfNeeded} title="Recarregar"><span className={"fa fa-sync" + (1 === fetching?" fa-spin":"")} /></Button></th>
          </tr>
          <tr>
            <th className="col-3">Unidade</th>
            <th className="col-4">Data</th>
            <th className="col-3">Tipo</th>
            <th className="col-2 text-right">Ações</th>
          </tr>
        </thead>
        {1 !== fetching && result.map((v, i) => (
          <ExpandableRow key={i}>
            <td className="col-3">{v.unidade}</td>
            <td className="col-4">{moment(v.data).calendar(null, {
              lastDay : '[Ontem]',
              sameDay : '[Hoje]',
              nextDay : '[Amanhã]',
              lastWeek : 'L',
              nextWeek : 'dddd',
              sameElse : 'L'
            })}</td>
            <td className="col-3">{t([
              "listaMudancas:tipos." + v.tipo
            ])}</td>
            <td className="col-2 text-right"><Button color="danger" size="sm" onClick={this.removeItem(v)} title="Cancelar Mudança"><span className="fa fa-minus"></span> <span className="d-none d-md-inline-block">Cancelar</span></Button></td>
          </ExpandableRow>
        ))}
        <tfoot>
          <tr>
            {[
              {columnProps: {className: "col-3"}, name: 'unidade', type: 'text', inputProps:{ maxLength: 6 }},
              {columnProps: {className: "col-7", colSpan:2}, name: 'data_mudanca', type: 'date', inputProps:{ required: true, min: moment().format('YYYY-MM-DD'), valid: !!data.data_mudanca && moment().isSameOrBefore(data.data_mudanca, 'day') }},
            ].map(v => (
              <th {...v.columnProps} key={v.name}><FormGroup {...v.labelProps}><Label hidden {...v.labelProps}>{v.name}</Label><Input bsSize="sm" type={v.type} disabled={1 === fetching} value={data[v.name]} onChange={this.onChange(v)} {...v.inputProps} /></FormGroup></th>
            ))}
            <th className="col-2 text-right"><ButtonGroup>
              <Button color="success" size="sm" disabled={disabled} onClick={this.addItem(true)} title="Registrar Entrada"><span className="fa fa-home"></span> <span className="d-none d-md-inline-block">Entrada</span></Button>
              <Button color="danger" size="sm" disabled={disabled} onClick={this.addItem(false)} title="Registrar Saída"><span className="fa fa-truck"></span> <span className="d-none d-md-inline-block">Saída</span></Button>
            </ButtonGroup></th>
          </tr>
        </tfoot>
      </Table>
      <Prompt toggle={this.handleToggle('promptEmail')} onConfirm={this.addItemEmail} isOpen={promptEmail} valid={value => 0 < value.indexOf("@") && value.lastIndexOf("@") < value.length - 1 && value.indexOf("@") === value.lastIndexOf("@") } inputProps={{type:"email", required:true}}>Informe o e-mail do novo morador para que seja enviado algumas instruções importantes.</Prompt>
    </Fragment>);
  }
}

let mapStateToProps = ({ mudancas }) => ({
  value: mudancas
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(null, {withRef:true})(ListaMudancas));



// WEBPACK FOOTER //
// ./src/modules/mudancas/ListaMudancas.js